import { useCallback, useMemo, useSyncExternalStore } from "react";
import { dayKey, getRoutineCompletions, countDailyCompletions, newRunId } from "./routineCompletions";
const empty = { events: {}, pending: {}, errors: {}, saving: new Set(), today: dayKey() };
export default function useRoutineCompletions(uid) {
  const service = useMemo(() => uid ? getRoutineCompletions(uid) : null, [uid]);
  const subscribe = useCallback((listener) => service ? service.subscribe(listener) : () => {}, [service]);
  const getSnapshot = useCallback(() => service?.getSnapshot() || empty, [service]);
  const current = useSyncExternalStore(subscribe, getSnapshot);
  return { ...current, record: service?.record, retry: service?.retry,
    count: (presetId) => countDailyCompletions(current.events, presetId, current.today),
    reset: (presetId) => service?.record({ runId: newRunId(), presetId, type: "reset",
      resetRunIds: Object.values(current.events).filter((event) => event.presetId === presetId && event.day === dayKey() && event.type !== "reset").map((event) => event.runId),
    }),
    status: (runId) => current.saving.has(runId) ? "saving" : current.pending[runId] ? "error" : current.events[runId] ? "saved" : null,
  };
}
